import { action, observable } from "mobx";
import { inject, observer } from "mobx-react";
import * as React from "react";
import * as DocumentManagement from "../DocumentManagement";
import { Toolbar } from "../General/Toolbar";
import { TypeAheadSearchInput } from "../General/TypeAheadSearchInput";
import { CollectionStoreImpl } from "../Stores/CollectionStore";
import { DialogStore } from "../Stores/DialogStore";
import { Strings } from "../Stores/StringsStore";




interface IPrivilegesSelectionProps {
	collectionID: string;
	store?: CollectionStoreImpl;
}

/**
 * component for privilege selection
 */
@inject('store')
@observer
export class PrivilegesSelection extends React.Component<IPrivilegesSelectionProps, {}> {
	/* Stores  privileges for a collection */
	@observable privilegesForGroups: DocumentManagement.PrivilegesForGroup[] = [];
	@observable searchTerm: string = "";
	searchTimeoutHandle: number;
	/* Stores selected privileges temporarily */
	@observable selectedPrivilege: DocumentManagement.PrivilegesForGroup[] = [];
	/*keep it for lazy loading afetr getUnassignedPrivileges API Success*/
	@observable removedPrivilegesForGroups: DocumentManagement.PrivilegesForGroup[] = [];

	componentWillMount() {
		this.props.store.saveSelectedPrivilege = this.handleSaveSelectedPrivilege;
		this.props.store.addedPrivileges.map((privilege) => {
			this.selectedPrivilege.push(privilege);
		});
	}

	/* invoke when a user clicks WizardBox confirmation YES Button. it adds selected privilege from temp `selectedPrivilege` to  observable array `selectedPrivilege`( a collection store object) for further updations.*/
	@action handleSaveSelectedPrivilege = () => {
		this.props.store.addedPrivileges = [];
		this.selectedPrivilege.map((privilege) => {
			if (this.props.store.removedCollectionPrivileges.some(p => p.groupId !== privilege.groupId)) {
				this.props.store.collection.privileges.privilegesForGroups.push(privilege);
				this.props.store.removedCollectionPrivileges = this.props.store.removedCollectionPrivileges.filter(p => p.groupId !== privilege.groupId);
			}
			else {
				this.props.store.addedPrivileges.push(privilege);
			}
		});
	}

	/* invoke when a user clicks any one  of the listed privilege. it adds selected privilege to temp observable array `selectedPrivilege` */
	onSelectionPrivilege = (selectedPrivilege: DocumentManagement.PrivilegesForGroup) => {
		if (this.selectedPrivilege.some(item => item.groupId === selectedPrivilege.groupId)) {
			this.selectedPrivilege = this.selectedPrivilege.filter((privilege) => {
				return privilege.groupId !== selectedPrivilege.groupId;
			});
		}
		else {
			let currentSelection = this.selectedPrivilege.filter(item => this.props.store.addedPrivileges.indexOf(item) == -1);
			if (currentSelection.length > 0) {
				this.selectedPrivilege.pop();
			}
			this.selectedPrivilege.push(selectedPrivilege);
		}
	}

	componentDidMount() {
		this.getUnassignedPrivileges();
	}
	/* Get all unassigned privilege for selection*/
	getUnassignedPrivileges = () => {
		this.props.store.collectionPrivilegesWizardState.isWizardBoxBusy = true;
		let query: DocumentManagement.CollectionPrivilegesQuery = new DocumentManagement.CollectionPrivilegesQuery();
		query.collectionId = this.props.collectionID;
		DocumentManagement.queryUnassignedCollectionPrivilegeInfosAsync(query).then((result: DocumentManagement.CollectionPrivileges) => {
			this.privilegesForGroups = result.privilegesForGroups.filter(item => !this.props.store.addedPrivileges.some(selectedItem => selectedItem.groupId === item.groupId));
			this.removedPrivilegesForGroups = this.props.store.removedCollectionPrivileges.filter(item => !this.props.store.addedPrivileges.some(selectedItem => selectedItem.groupId === item.groupId));
			this.moveAndSortPrivileges();
			this.props.store.collectionPrivilegesWizardState.isWizardBoxBusy = false;			
		}).catch((error) => {
			this.props.store.collectionPrivilegesWizardState.isWizardBoxBusy = false;
			DialogStore.showError(Strings.general.errorDialogTitle, error);
		});
	}

	handleSearchTermChangeFromTypeAhead = (searchTerm: string) => {
		this.searchTerm = searchTerm;
		clearTimeout(this.searchTimeoutHandle);
		this.searchTimeoutHandle = setTimeout(() => this.search(), 300);
	}

	/*
	* Search Logic
	*/
	search = () => {
		let query: DocumentManagement.CollectionPrivilegesQuery = new DocumentManagement.CollectionPrivilegesQuery();
		query.collectionId = this.props.collectionID;
		query.searchTerm = this.searchTerm;
		DocumentManagement.queryUnassignedCollectionPrivilegeInfosAsync(query).then((result: DocumentManagement.CollectionPrivileges) => {
			this.privilegesForGroups = result.privilegesForGroups.filter(item => !this.props.store.addedPrivileges.some(selectedItem => selectedItem.groupId == item.groupId));
			this.removedPrivilegesForGroups = this.props.store.removedCollectionPrivileges.filter(item => this.props.store.addedPrivileges.some(selectedItem => selectedItem.groupId == item.groupId));
			if (query.searchTerm) {
				this.removedPrivilegesForGroups = this.removedPrivilegesForGroups.filter((item) => {
					return item.groupName.toLowerCase().search(query.searchTerm) != -1;
				});
			}
			this.moveAndSortPrivileges();
		}).catch((error) => DialogStore.showError(Strings.general.errorDialogTitle, error));
	}


	moveAndSortPrivileges = () => {
		for (let i = 0; i < this.removedPrivilegesForGroups.length; i++) {
			this.privilegesForGroups.push(this.removedPrivilegesForGroups[i]);
		}
		this.privilegesForGroups = this.privilegesForGroups.sort((a: DocumentManagement.PrivilegesForGroup, b: DocumentManagement.PrivilegesForGroup) => {
			if (a.groupName < b.groupName) return -1;
			if (a.groupName > b.groupName) return 1;
			return 0;
		});
	}

	render() {
		return <div className="wizardbox-content">
			<Toolbar>
				<TypeAheadSearchInput showSuggestionList={false} searchTermChangeCallback={this.handleSearchTermChangeFromTypeAhead} />
			</Toolbar>
			<div className="wizardbox-module">
				<div className="list-simple">
					<ul>
						{
							this.privilegesForGroups.map(item => {
								return <PrivilegesSelectionItem selectedPrivilege={this.selectedPrivilege} onSelectionChange={this.onSelectionPrivilege} key={item.groupId} item={item} collectionsStore={this.props.store} />;
							})
						}
						{
							//	this.removedPrivilegesForGroups.map(item => {
							//		return <PrivilegesSelectionItem selectedPrivilege={this.selectedPrivilege} onSelectionChange={this.onSelectionPrivilege} key={item.groupId} item={item} collectionsStore={this.props.store} />;
							//	})
						}
					</ul>
				</div>
			</div>
		</div>;
	}
}


interface ICollectionItemProps {
	item: DocumentManagement.PrivilegesForGroup;
	collectionsStore: CollectionStoreImpl;
	/* pass selected privilege to child component */
	selectedPrivilege: DocumentManagement.PrivilegesForGroup[];
	/* Invoke parent onSelectionPrivilege event */
	onSelectionChange: (selectedPrivilege: DocumentManagement.PrivilegesForGroup) => void;
}

/**
 * Render UnAssigned privileges
 */
@observer
class PrivilegesSelectionItem extends React.Component<ICollectionItemProps, {}> {

	@action handleClickItem = () => {
		this.props.onSelectionChange(this.props.item);
	}

	render() {
		let selectedPrivilegeClass = this.props.selectedPrivilege.some(item => item.groupId === this.props.item.groupId) ? "is--selection-selected" : "";
		return <li className={selectedPrivilegeClass} onClick={this.handleClickItem}>
			<a>
				<span id={this.props.item.groupId}>
					{this.props.item.groupName}
				</span>
			</a>
		</li>;
	}

}